/* eslint-disable vue/return-in-computed-property */
<template>
  <v-dialog
    persistent
    v-model="show"
    max-width="430"
    content-class="popup-wrap-1"
  >
    <div class="pa-8">
      <h3 class="title-type-4 mb-2">{{ propsFileItem.name }}</h3>

      <div class="previewImage mt-8">
        <div v-if="filePath">
          <img :src="transImg(filePath)" alt="" />
        </div>
      </div>
      <div class="d-flex justify-center mt-8">
        <v-btn
          large
          depressed
          max-height="40px"
          min-width="104px"
          color="#fecd06"
          class="button-type-1"
          @click.stop="confirm"
        >
          확인
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  props: {
    value: Boolean,
    propsItem: Object,
    propsFileItem: Object,
  },
  data: () => ({}),
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    filePath: {
      get() {
        return this.propsFileItem.file;
      },
      set(value) {
        this.propsFileItem = value;
      },
    },
  },
  methods: {
    confirm() {
      this.show = false;
    },
    transImg(fileName) {
      return fileName.includes('%s')
        ? fileName.replace('/%s.jpg', '/h.jpg')
        : fileName;
    },
  },
};
</script>

<style lang="scss" scoped>
.previewImage {
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    max-width: 360px;
    max-height: 640px;
  }
}
</style>
